import { Container as Container_} from '@chakra-ui/react'
import { forwardRef } from "react"
export const Container = forwardRef(({...props}, ref) => {
    return <Container_ ref={ref} {...props}>{props?.children}</Container_>
});